// This file exposes the global Phaser object to ES modules
export default window.Phaser;
